import styles from './Top.module.scss'
import Button from 'components/common/Button/Button'
import React, { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const Top: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)
  return (
    <section
      className={`${styles.FV} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.FV__inner}>
        <h1 className={styles.FV__logo}>
          <figure>
            <img src="/img/common/logo_zebra.svg" alt="ZEBRA" width={240} height={54} />
          </figure>
        </h1>
        <p className={styles.FV__subTitle}>マーケティング担当の方必見</p>
        <h2 className={styles.FV__title}>
          シンプルで直感的に使いやすい
          <br />
          プッシュ通知サービスの決定版
        </h2>
        <p className={styles.FV__text}>
          顧客属性DBを活用し、細やかなセグメント配信で効果的なコミュニケーションを実現します
        </p>
        <ul className={styles.FV__list}>
          <li className={styles.FV__list__item}>SDKで簡単導入</li>
          <li className={styles.FV__list__item}>セグメント・全体配信</li>
          <li className={styles.FV__list__item}>リッチ配信</li>
          <li className={styles.FV__list__item}>セキュリティ万全</li>
          <li className={styles.FV__list__item}>カスタマイズ可能</li>
          <li className={styles.FV__list__item}>安心な料金設定</li>
        </ul>
        <div className={styles.FV__contact}>
          <Button text="お問い合わせ" href="/contact/" red="red" />
        </div>
        <figure className={styles.FV__image}>
          <img src="/img/LP/zebra/kv.png" alt="ZEBRA" width={1004} height={1015} className={styles.top_image} />
        </figure>
      </div>
    </section>
  )
}
export default Top
